/**
 * Combines classnames together
 */
export const C = (...args) => args.filter(Boolean).join(' ');
